import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function PlayIcon({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 22 20'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M10.9902 0.017334C16.5134 0.017334 20.9902 4.49419 20.9902 10.0173C20.9902 15.5405 16.5134 20.0173 10.9902 20.0173C5.46709 20.0173 0.990234 15.5405 0.990234 10.0173C0.990234 4.49419 5.46709 0.017334 10.9902 0.017334ZM10.9902 1.01733C6.01938 1.01733 1.99023 5.04648 1.99023 10.0173C1.99023 14.9882 6.01938 19.0173 10.9902 19.0173C15.9611 19.0173 19.9902 14.9882 19.9902 10.0173C19.9902 5.04648 15.9611 1.01733 10.9902 1.01733ZM7.67533 6.42363V13.6106C7.67533 14.2195 8.33971 14.5945 8.86092 14.2812L14.7683 10.6847C15.27 10.3826 15.27 9.65266 14.7663 9.34931L8.86334 5.75556C8.34013 5.44106 7.67533 5.81426 7.67533 6.42363ZM13.941 10.0176L8.67533 13.2234V6.81183L13.941 10.0176Z' />
    </svg>
  );
}
